import { Injectable } from '@angular/core';
import { Validators, AbstractControl, ValidationErrors } from '@angular/forms';
@Injectable()
export class CustomValidator {
    constructor() {}

    static emailEmptyValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        return Validators.email(control);
    }

    static DecimalTopCero(control: AbstractControl): ValidationErrors | null {
        let strPeso: string = control.value.toString();
        strPeso = strPeso.replace('.', '');
        strPeso = strPeso.replace(',', '.');

        let peso: number = parseFloat(strPeso);

        if (peso > 0 || strPeso == '') {
            return null;
        } else {
            return { DecimalTopCero: true };
        }
    }

    static PesoFormatoValido(control: AbstractControl): ValidationErrors | null {
        if (control.value === null || control.value === '') {
            return null; // Campo vacío permitido
        }

        let strPeso: string = control.value.toString().trim().replace(',', '.');

        const peso = parseFloat(strPeso);

        if (isNaN(peso)) {
            return { PesoFormatoValido: true };
        }

        // Separar parte entera y decimal
        const partes = strPeso.split('.');
        const enteros = partes[0] || '';
        const decimales = partes[1] || '';

        // Validar máximo 13 dígitos enteros
        if (enteros.length > 13) {
            return { PesoFormatoValido: true };
        }

        // Validar máximo 5 dígitos decimales
        if (decimales.length > 5) {
            return { PesoFormatoValido: true };
        }

        return null;
    }

    static NIFValidator(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        if (!/^[XYZxyz]?[0-9]{7,8}[a-zA-Z]{1}$/.test(control.value)) {
            /* No es un NIF de persona física con formato correcto */

            /* El siguiente paso es comprobar si el formato corresponde a un nif de persona jurí­dica
             * (el antiguo CIF) */

            //	El número CIF consta de 9 dí­gitos alfanuméricos con la siguiente estructura: O P P N N N N N C
            //	Siendo O: Tipo de Organización  ; P: Código provincia  ; N: Número correlativo por provincia ; C: Dí­gito o letra de control
            //
            //	TIPO DE ORGANIZACION (Letra O)
            //	==============================
            //	A - Sociedad Anónima. 	B - Sociedad de Responsabilidad Limitada. 	C - Sociedad Colectiva.
            //	D - Sociedad Comanditaria. 	E - Comunidad de Bienes. 	F - Sociedad Cooperativa.
            //	G - Asociaciones y otros tipos no definidos. 	H - Comunidad de propietarios en régimen de propiedad horizontal.
            //	N - Entidades no residentes. 	P - Corporación local. 	Q - Organismo autónomo estatal o no, y asimilados, congregaciones e instituciones religiosas.
            //	S - Organos de la Administración del Estado y Comunidades Autónomas
            //
            //	CODIGO DE LA PROVINCIA (Letra P)
            //	================================
            //	01 - Alava. 02 - Albacete. 	03, 53, 54 - Alicante. 	04 - Almería. 	05 - ívila. 	06 - Badajoz.
            //	07, 57 - Islas Baleares. 	08, 58, 59, 60, 61, 62, 63, 64 - Barcelona. 	09 - Burgos. 	10 - Cáceres. 	11, 72 - Cádiz. 	12 - Castellón.
            //	13 - Ciudad Real. 	14, 56 - Córdoba. 	15, 70 - A Coruña. 	16 - Cuenca. 	17, 55 - Girona. 	18 - Granada.
            //	19 - Guadalajara. 	20, 71 - Guipúzcoa. 	21 - Huelva. 	22 - Huesca. 	23 - Jaén. 	24 - León.
            //	25 - Lleida. 	26 - La Rioja. 	27 - Lugo. 	28, 78, 79, 80, 81, 82, 83, 84 - Madrid. 	29, 92, 93 - Málaga. 	30, 73 - Murcia.
            //	31 - Navarra. 	32 - Ourense. 	33, 74 - Oviedo. 	34 - Palencia. 	35, 76 - Las Palmas. 	36, 94 - Pontevedra.
            //	37 - Salamanca. 	38, 75 - Santa Cruz de Tenerife. 	39 - Cantabria. 	40 - Segovia. 	41, 91 - Sevilla. 	42 - Soria.
            //	43, 77 - Tarragona. 	44 - Teruel. 	45 - Toledo. 	46, 96, 97, 98 - Valencia. 	47 - Valladolid. 	48, 95 - Vizcaya.
            //	49 - Zamora. 	50, 99 - Zaragoza. 	51 - Ceuta. 	52 - Melilla.
            //
            //	NUMERO CORRELATIVO (Letra N)
            //	============================
            //	Es asignado de forma correlativa y cronológica por la Administración.
            //
            //	LETRA O NUMERO DE CONTROL (Letra C)
            //	===================================
            //	Es una letra si la clave de la  organización es K, P, Q ó S y es un número si la clave de la organización
            //	es A, B, E ó H. Para el resto de claves indentificativas del tipo de organización podrá ser tanto número como letra.

            /*Comprobar si se trata de persona jurí­dica de tipo A,B,E o H */

            if (!/^[ABEHabeh]{1}[0-9]{8}$/.test(control.value)) {
                /* Tampoco es un NIF de persona jurí­dica (A,B,E,H) con formato correcto */

                /*Comprobar si se trata de persona jurí­dica de tipo P, Q ó S */

                if (!/^[PQSpqs]{1}[0-9]{7}[a-zA-Z]{1}$/.test(control.value)) {
                    /* Tampoco es un NIF de persona jurí­dica (P, Q ó S) con formato correcto */

                    /*Comprobar si se trata de persona jurí­dica del resto de tipos */

                    if (!/^[CDFGJRUVNWcdfgjruvnw]{1}[0-9]{7}[0-9a-zA-Z]{1}$/.test(control.value)) {
                        /* Tampoco es un NIF de persona jurí­dica de los tipos C,D,F,G,J,R,U,V,N ó W
                         * con formato correcto */

                        /* Comprobar si se trata de un EORI */
                        /* El código EORI empieza por ES (de España) y va seguido del NIF
                         * asignado por Hacienda */

                        if (
                            !/^ES[XYZxyz]?[0-9]{7,8}[a-zA-Z]{1}$/.test(control.value) &&
                            !/^ES[ABEHabeh]{1}[0-9]{8}$/.test(control.value) &&
                            !/^ES[PQSpqs]{1}[0-9]{7}[a-zA-Z]{1}$/.test(control.value) &&
                            !/^ES[CDFGJRUVNWcdfgjruvnw]{1}[0-9]{7}[0-9a-zA-Z]{1}$/.test(control.value) &&
                            !/^[A-Z]{2}[0-9A-Za-z]{7,15}$/.test(control.value)
                        )
                            /* Finalmente no es un EORI correcto tampoco */

                            return { NIF: true };
                    }
                }
            }
        }

        return null;
    }

    static CodigoTaric(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        if (!/^\d{2}(\d{2}){0,4}$/.test(control.value)) {
            return { CodigoTaric: true };
        }

        return null;
    }

    static CodigoTaricMin4(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        if (!/^\d{4}(\d{2}){0,3}$/.test(control.value)) {
            return { CodigoTaricMin4: true };
        }

        return null;
    }
}
